import React, { useEffect, useMemo, useState } from 'react';
import Select from 'antd/lib/select';
import {
  DatePicker,
  Input,
  Row,
  InputNumber,
  FormInstance,
  Col,
  Divider,
  Form,
  Spin,
} from 'antd';

import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import ThirdPartyInput from 'components/ThirdPartyInput';
import { useQuery } from 'react-query';
import { getProposalById } from 'services/proposal';
import InputCurrency from 'components/InputCurrency';
import moment from 'moment';
import GetLabel from 'DisplayFramework/components/GetLabel';
import Value from 'components/Value';
import Checkbox from 'components/Checkbox';
import _, { debounce, isNil, isUndefined } from 'lodash';
import {
  findGuarantyListByAnyRef,
  getGuarantyByID,
  getGuarantyListByCTRID,
  getGuarBeneficiaryList,
  // GuarantyListSearchResponse,
} from 'services/guaranty';
import { toCurrency } from 'utils/utils';
import { shouldUpdateCompare, toDatePickerDate } from 'utils/utils2';
import ParGuarCodeSelect from 'components/ParGuarCodeSelect';
import Address from 'components/address';
import { getThirdPartyById } from 'services/thirdParty';

const { TextArea } = Input;

export type TabDecisionProps = {
  objectid?: number;
  form?: FormInstance;
  setSuccessful: any;
};
const TabGuaranty = ({ objectid, form, setSuccessful }: TabDecisionProps) => {

  const stableObjectId = useMemo(() => objectid, [objectid]);

  const { data, isFetching ,  refetch: refetchProposalById} = useQuery(
    ['getProposalById', { ctrid: stableObjectId }],
    () => getProposalById({ ctrid: stableObjectId! }).then((res) => res.data),
    { 
      enabled: false
     }
  );

  useEffect(() => {
    if (stableObjectId) {
      refetchProposalById();
    }
  }, [stableObjectId, refetchProposalById]);

  useEffect(() => {
    setSuccessful(isFetching);
  }, [isFetching]);

  const [clientIsGuaranor, setClientIsGuaranor] = useState(false);
  const [Guaranor, setGuaranor] = useState<{
    tpid?: number;
    tpreference?: string;
    tpname?: string;
  }>();
  const [isDisabled, setisDisabled] = useState<boolean>(false);
  const [clear, setClear] = useState(false);

  // const { getComponentLabel } = useDisplayFrameworkContext();

  // eslint-disable-next-line no-unused-vars
  const [tpList, setTpList] = useState<Array<any>>([]);

  const [tp, setTP] = useState(0);

  const [loading, setIsLoading] = useState(false);

  const { data: thirdparty, refetch: refetchTp } = useQuery(
    ['getThirdPartyById', { tpid: tp }],
    () => getThirdPartyById({ tpid: tp }).then((res) => res.data),
    { enabled: !!tp }
  );

  useEffect(() => {
    if (data && !clear) {
      setTpList(
        data.thirdParties.filter(
          (e) => e.tprolecode === 'CLIENT' || e.tprolecode === 'GUAR'
        )
      );
      const elemFin = data.conElements.find(
        (element) => element.ctetype === 'FIN'
      );

      form?.setFieldsValue({
        beneficiary: {
          tpid: data.tpidclient,
          tpreference: data.clientreference,
          tpname: data.clientname,
        },
        beneficiaryname: data.clientname,
        guarusageamount:
          Number(form.getFieldValue('guarusageamount')) !==
            elemFin?.ctefinancedamount &&
          Number(form.getFieldValue('guarusageamount')) !== 0
            ? form.getFieldValue('guarusageamount')
            : elemFin?.ctefinancedamount,
        currcode: elemFin?.currcode,
        guarreceptiondate: form.getFieldValue('guarreceptiondate') ?? moment(),
        guarsignaturedate: form.getFieldValue('guarsignaturedate') ?? moment(),
        clientreference: data.clientreference,
        ctefinancedamount: elemFin?.ctefinancedamount,
      });
      setClear(false);
    }
    if (thirdparty) {
      form?.setFieldsValue({
        guaradrstreet1: thirdparty?.address.tpmainadrstreet1,
        guaradrcity: thirdparty?.address.tpmainadrcity,
        guaradrregion: thirdparty?.address.tpmainadrregion,
        guaradrzipcode: thirdparty?.address.tpmainadrzipcode,
        guaradrcountry: thirdparty?.address.tpmainadrcountry,
      });
    }
  }, [data, form, clear, tp, thirdparty]);
  const changeGar = (checked: boolean) => {
    if (checked) {
      setGuaranor({
        tpid: data?.tpidclient,
        tpreference: data?.clientreference,
        tpname: data?.clientname,
      });
      form?.setFieldsValue({
        guarantor: {
          tpid: data?.tpidclient,
          tpreference: data?.clientreference,
          tpname: data?.clientname,
        },
        guaradrstreet1: data?.ctinvoiceaddressstr1,
        guaradrcity: data?.ctinvoiceaddresscity,
        guaradrregion: data?.tpinvoiceaddressregion,
        guaradrzipcode: data?.ctinvoiceaddresszipcode,
        guaradrcountry: data?.thirdParties[0].address.tpmainadrcountry,
      });
    } else {
      form?.setFieldsValue({
        guarantor: {
          tpid: undefined,
          tpreference: undefined,
          tpname: undefined,
        },
        guaradrstreet1: '',
        guaradrcity: '',
        guaradrregion: '',
        guaradrzipcode: '',
        guaradrcountry: '',
      });
      setGuaranor({ tpid: 0, tpreference: '', tpname: '' });
    }
    setClientIsGuaranor(checked);
  };

  const [searchParams, setSearchParams] = useState<any>({
    tpname: '',
    tpreference: '',
    ctreference: '',
    beneficiaryname: '',
    guarreference: '',
    guarstatus: 'ACTIVE',
    guartype: '',
    guarcode: '',
    propreference: '',
    refguarantor: '',
    tpidguarantor: 0,
    tpidbeneficiary: undefined,
  });

  const { data: guaranties } = useQuery(
    ['findGuarantyListByAnyRef', searchParams],
    () => findGuarantyListByAnyRef(searchParams).then((res) => res.list || []),
    { enabled: searchParams.tpidbeneficiary !== undefined }
  );

  const onChangeguaramount = debounce((e: any) => {
    setIsLoading(false);

    if (
      !loading &&
      Number(form?.getFieldValue('guaramount')) <=
        Number(form?.getFieldValue('ctefinancedamount'))
    ) {
      form?.setFieldValue('guarusageamount', form?.getFieldValue('guaramount'));
    }else {
      form?.setFieldValue('guarusageamount', form?.getFieldValue('ctefinancedamount'));

    }
  }, 1000);

  useEffect(() => {
    if (data) {
      setSearchParams({
        tpname: '',
        tpreference: '',
        ctreference: '',
        beneficiaryname: '',
        guarreference: '',
        guarstatus: 'ACTIVE',
        guartype: '',
        guarcode: '',
        propreference: '',
        refguarantor: '',
        tpidguarantor: 0,
        tpidbeneficiary: data?.tpidclient,
      });
    }
  }, [data]);

  const [guarrID, setGuarrID] = useState<number>();

  const { data: guaranty } = useQuery(
    [Number(guarrID), `getGuarantyByID`],
    () =>
      getGuarantyByID({ guarid: Number(guarrID) }).then(
        (res) => res.data || {}
      ),
    { enabled: !!guarrID }
  );

  const { data: guarantyBeneficiary } = useQuery(
    ['getGuarBeneficiaryList', { guarid: Number(guarrID) }],
    () =>
      getGuarBeneficiaryList({ guarid: Number(guarrID) }).then(
        (res) => res.list || []
      ),
    { enabled: !!guarrID }
  );

  useEffect(() => {
    if (guaranty && guarantyBeneficiary) {
      const elemFin = data?.conElements.find(
        (element) => element.ctetype === 'FIN'
      );
      setisDisabled(true);
      const guarBeneficiary = guarantyBeneficiary.find(
        (guarBeneficiary) =>
          guarBeneficiary.tpidbeneficiary === data?.tpidclient
      );
      setClientIsGuaranor(true);

      form?.setFieldsValue({
        guartype: guaranty?.guartype,
        guarcode: guaranty?.guarcode,
        guarexternalref: guaranty?.guarexternalref,
        guaramount: guaranty?.guarremainamount,
        guarusageamount:
          Number(guarBeneficiary?.guarusageamount) <
          Number(guaranty?.guarremainamount)
            ? guarBeneficiary?.guarusageamount
            : guaranty?.guarremainamount,
        guarrank: guaranty?.guarrank,
        guarreceptiondate: toDatePickerDate(guaranty.guarreceptiondate),
        guarsignaturedate: toDatePickerDate(guaranty.guarsignaturedate),
        guaradrstreet1: guaranty?.guaradrstreet1,
        guaradrstreet2: guaranty?.guaradrstreet2,
        guaradrcity: guaranty?.guaradrcity,
        guaradrregion: guaranty?.guaradrregion,
        guaradrzipcode: guaranty?.guardrzipcode,
        guaradrcountry: guaranty?.guaradrcountry,
        guardescription: guaranty?.guardescription,
        guarremainamount: guaranty?.guarremainamount,
        ctefinancedamount: elemFin?.ctefinancedamount,
        guarantor: {
          tpid: guaranty?.tpidguarantor,
          tpreference: guaranty.guarantorreference,
          tpname: guaranty.guarantorname,
        },
      });
      setGuaranor({
        tpid: guaranty?.tpidguarantor,
        tpreference: guaranty.guarantorreference,
        tpname: guaranty.guarantorname,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guaranty,guarantyBeneficiary,form,isDisabled]);

  const clearForm = () => {
    // eslint-disable-next-line no-lone-blocks
    {
      setGuaranor({ tpid: 0, tpreference: '', tpname: '' });
      setClear(true);
      setisDisabled(false);
      const elemFin = data?.conElements.find(
        (element) => element.ctetype === 'FIN'
      );
      form?.setFieldsValue({
        ...initialValues,
        guarusageamount: elemFin?.ctefinancedamount,
      });
      setClientIsGuaranor(false);
    }
  };

  const {
    data: guarantees,
    isFetching: fetching,
    refetch,
  } = useQuery(
    ['getGuarantyListByCTRID', objectid],
    () =>
      getGuarantyListByCTRID({ ctrid: objectid! }).then(
        (res) => res.list || []
      ),
    { enabled: !isNil(objectid) }
  );

  const guarReferences = guarantees?.map((guar) => guar.guarreference) || [];
  const filteredGuaranties = guaranties?.filter(
    (guaranty) => !guarReferences.includes(guaranty.guarreference)
  );

  const uniqueGuarreferences = Array.from(
    new Set(filteredGuaranties?.map((guaranty) => guaranty.guarreference))
  );

  return (
    <DF.Provider pagcode="tabguaranty">
      <Spin spinning={isFetching}>
        <Form
          name="formGuaranty"
          form={form}
          initialValues={initialValues}
          style={{ textAlign: 'left' }}
        >
          <Col span={24}>
            {/* // add here a ListSelect of existing guaranties:  (use finGuarantyByanyRef : set tpidbeneficiary = tpiclient of proposal) */}
            {guaranties !== undefined &&
              guaranties.length > 0 &&
              uniqueGuarreferences.length > 0 && (
                <Col span={12}>
                  <FormInput name="guarid">
                    <Select
                      onClear={() => {
                        clearForm();
                        setClientIsGuaranor(false);
                      }}
                      allowClear
                      onChange={(e) => {
                        setGuarrID(Number(e));
                      }}
                    >
                      {uniqueGuarreferences.map((guarreference) => {
                        const filteredGuaranties = guaranties.filter(
                          (guaranty) => guaranty.guarreference === guarreference
                        );

                        return (
                          <Select.Option
                            key={guarreference}
                            value={filteredGuaranties[0].guarid}
                          >
                            {filteredGuaranties[0].guarreference} -{' '}
                            {filteredGuaranties[0].typelabel} -{' '}
                            {filteredGuaranties[0].guarantorname} (
                            {toCurrency(
                              filteredGuaranties[0].guaramount,
                              filteredGuaranties[0].currcode ??
                                localStorage.getItem('currcode')
                            )}
                            )
                          </Select.Option>
                        );
                      })}
                      {/* {guaranties?.map((guaranty: GuarantyListSearchResponse) => (
                      <Select.Option
                        value={guaranty.guarid}
                        key={guaranty.guarid}
                      >
                        {guaranty.guarreference +
                          ' - ' +
                          guaranty.typelabel +
                          ' - ' +
                          guaranty.guarantorname +
                          ' ( ' +
                          toCurrency(
                            guaranty.guaramount,
                            guaranty.currcode ?? localStorage.getItem('currcode') ?? ''
                          ) +
                          ' ) '}
                      </Select.Option>
                    ))} */}
                    </Select>
                  </FormInput>
                </Col>
              )}
            <Divider orientation="left">
              <GetLabel label="guarantyInfo" />
            </Divider>
            <div style={{ paddingLeft: 10, paddingRight: 10 }}>
              <Row gutter={[10, 10]}>
                <FormInput
                  labelAlign="left"
                  labelCol={{ span: 9 }}
                  col
                  xs={12}
                  lg={6}
                  name="guarexternalref"
                  rules={[{ required: true }]}
                >
                  <Input disabled={isDisabled} />
                </FormInput>
                <FormInput
                  labelAlign="left"
                  labelCol={{ span: 8 }}
                  col
                  xs={12}
                  lg={6}
                  name="guartype"
                  rules={[{ required: true }]}
                >
                  <ParListSelect disabled={isDisabled} parcode="GUARTYPE" />
                </FormInput>
                <Form.Item
                  shouldUpdate={shouldUpdateCompare('guartype')}
                  noStyle
                >
                  {({ getFieldValue }) => (
                    <FormInput
                      labelAlign="left"
                      col
                      xs={24}
                      lg={5}
                      name="guarcode"
                    >
                      <ParGuarCodeSelect guartype={getFieldValue('guartype')} />
                    </FormInput>
                  )}
                </Form.Item>
                <FormInput
                  labelAlign="left"
                  labelCol={{ span: 9 }}
                  col
                  xs={12}
                  lg={6}
                  name="guarreceptiondate"
                  rules={[{ required: true }]}
                >
                  <DatePicker disabled={isDisabled} />
                </FormInput>
              </Row>
              <Row gutter={[10, 10]}>
                <FormInput
                  labelAlign="left"
                  labelCol={{ span: 9 }}
                  col
                  xs={12}
                  lg={6}
                  name="guarsignaturedate"
                  rules={[{ required: true }]}
                >
                  <DatePicker disabled={isDisabled} />
                </FormInput>

                <FormInput
                  labelAlign="left"
                  labelCol={{ span: 12 }}
                  wrapperCol={{ span: 12 }}
                  col
                  xs={12}
                  lg={4}
                  name="guarrank"
                  rules={[{ required: true }]}
                >
                  <InputNumber disabled={isDisabled} min={0} />
                </FormInput>
                <FormInput
                  labelAlign="left"
                  labelCol={{ span: 9 }}
                  col
                  xs={12}
                  lg={6}
                  name="ctefinancedamount"
                >
                  <InputCurrency
                    disabled
                    width="md"
                    currcode={form?.getFieldValue('currcode')}
                  />
                </FormInput>
                <FormInput
                  labelAlign="left"
                  labelCol={{ span: 9 }}
                  col
                  xs={12}
                  lg={6}
                  name="guaramount"
                  rules={[{ required: true }]}
                >
                  <InputCurrency
                    disabled={isDisabled}
                    onChange={(e) => {
                      setIsLoading(true);
                      onChangeguaramount(e);
                    }}
                    currcode={form?.getFieldValue('currcode')}
                  />
                </FormInput>
                <Col xs={12} lg={6}>
                  <Spin spinning={loading}>
                    <Form.Item noStyle shouldUpdate>
                      {({ getFieldValue }) => (
                        <FormInput
                          labelAlign="left"
                          labelCol={{ span: 10 }}
                          col
                          xs={24}
                          lg={24}
                          name="guarusageamount"
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                          shouldUpdate
                        >
                          <InputCurrency
                            width="md"
                            min={0}
                            max={_.min([
                              form?.getFieldValue('guaramount'),
                              form?.getFieldValue('ctefinancedamount'),
                            ])}
                            currcode={form?.getFieldValue('currcode')}
                          />
                        </FormInput>
                      )}
                    </Form.Item>
                  </Spin>
                </Col>
              </Row>
            </div>

            {/* <Tabs> */}
            {/* <TabPane tab="Guarantor & Beneficiary" key={1}>

              </TabPane> */}

            {/* <TabPane tab="Notes & comments" key={3}>

              </TabPane> */}
            {/* </Tabs> */}
            <Divider orientation="left" style={{ paddingTop: '7px' }}>
              <GetLabel label="Guarantor & Beneficiary" />
            </Divider>
            <div style={{ paddingLeft: 10, paddingRight: 10 }}>
              <Row gutter={[16, 16]} style={{ height: '40px' }}>
                <Col xs={6}>
                  <Form.Item
                    hidden
                    labelAlign="left"
                    style={{ fontWeight: 'bold' }}
                    label="beneficiary"
                    name="beneficiary"
                  ></Form.Item>
                  <FormInput
                    name="beneficiaryname"
                    style={{ fontWeight: 'bold' }}
                  >
                    <Value />
                  </FormInput>
                </Col>
                <Col xs={18}>
                  <div style={{ display: 'flex', flexWrap: 'nowrap' }}>
                    <Col style={{ paddingTop: '7px' }}>
                      <GetLabel label="guarantor" />
                    </Col>
                    <Col style={{ marginTop: '3px' }}>
                      <Form.Item name="isClient">
                        <Checkbox
                          disabled={isUndefined(data?.clientname) || isDisabled}
                          comcode="client"
                          checked={clientIsGuaranor}
                          onChange={(e) => {
                            changeGar(e.target.checked);
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col style={{ display: 'flex', flexWrap: 'nowrap' }}>
                      <div style={{ display: 'flex', flexWrap: 'nowrap' }}>
                        <Form.Item
                          style={{ width: '300px' }}
                          labelAlign="left"
                          labelCol={{ span: 7 }}
                          name="guarantor"
                        >
                          <div>
                            {clientIsGuaranor || isDisabled ? (
                              <Input
                                disabled
                                value={
                                  Guaranor
                                    ? Guaranor?.tpreference +
                                      ' - ' +
                                      Guaranor?.tpname
                                    : undefined
                                }
                                style={{ width: '350px' }}
                              />
                            ) : (
                              <ThirdPartyInput
                                role="GUAR"
                                value={Guaranor}
                                onChange={(e) => {
                                  setGuaranor(e);
                                  form?.setFieldsValue({
                                    guarantor: {
                                      tpid: e.tpid,
                                      tpname: e.tpname,
                                      tpreference: e.tpreference,
                                    },
                                  });
                                  setTP(e.tpid);
                                }}
                                style={{ width: '350px' }}
                              />
                            )}
                          </div>
                        </Form.Item>
                      </div>
                    </Col>
                  </div>
                </Col>
              </Row>
            </div>

            {/* <TabPane tab="Address" key={2}>

              </TabPane> */}
            <Divider orientation="left">
              <GetLabel label="Address" />
            </Divider>
            <Row gutter={16}>
              <FormInput
                labelAlign="left"
                col
                xs={12}
                lg={6}
                name="guaradrstreet1"
              >
                <Input disabled={isDisabled} />
              </FormInput>
              <FormInput
                labelAlign="left"
                col
                xs={12}
                lg={6}
                name="guaradrstreet2"
              >
                <Input disabled={isDisabled} />
              </FormInput>
              <Address
                colU={6}
                form={form!}
                paysField="guaradrcountry"
                regionField="guaradrregion"
                villeField="guaradrcity"
                codePostalField="guaradrzipcode"
                hideRegionGlobal
              />
            </Row>
            <Divider orientation="left">
              <GetLabel label="Comments" />
            </Divider>
            <Row>
              <Col xs={20}>
                <FormInput
                  labelAlign="left"
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 20 }}
                  name="guardescription"
                >
                  <TextArea disabled={isDisabled} rows={4} />
                </FormInput>
              </Col>
            </Row>
          </Col>
        </Form>
      </Spin>
    </DF.Provider>
  );
};

const initialValues = {
  entity: '',
  guaradrcity: '',
  guaradrregion: '',
  guaradrstreet1: '',
  guaradrstreet2: '',
  guaradrzipcode: '',
  guardescription: '',
  guarexternalref: '',
  guaradrcountry: '',
  guarrank: '',
  guarreceptiondate: undefined,
  guarsignaturedate: undefined,
  guartype: '',
  guaramount: undefined,
  guarusageamount: 0,
};

export default TabGuaranty;
